import { Component, OnInit, ViewChild } from '@angular/core';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Router } from '@angular/router';

import { User } from 'src/app/front-user/shared/models/user.model';
import { ErrorsEnum, ServiceStatus } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { DatePipe } from '@angular/common';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { CircularsFixedRebateOptions } from 'src/app/shared/models/circular.model';
import { CircularService } from '../../../../../app/shared/services/circular.service';

@Component({
  selector: 'app-circulars-confirm-ship-passing',
  templateUrl: './circulars-confirm-ship-passing.component.html'
})

export class CircularsConfirmShipPassingComponent implements OnInit {
  //#region Properties & Variables
  private circularsRequestId: string = "";
  @ViewChild('circularsRequest',{static: false}) circularsRequest: CircularRequestComponent;
  public isRequestSucceeded: boolean = false;
  //Options
  private isPassingdateSeventy: boolean = false;
  public circularsRequestOptions: CircularsFixedRebateOptions[] = [];
  // private getRequestOptionsDetailsRequest: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  // private getRequestOptionsDetailsRequestResponseObject: ResponseObject = new ResponseObject();
  // private getRequestOptionsDetailsResponse: LongHaulRequestFormulateDecision = new LongHaulRequestFormulateDecision();
  private selectedCircularsOption: CircularsFixedRebateOptions = new CircularsFixedRebateOptions();
  private previouslySelectedOption: CircularsFixedRebateOptions = new CircularsFixedRebateOptions();
  private optionPercentage: string;
  private isOptionDetailsEnabled: boolean = false;
  //Passing Date
  private passingDateMaxDate: Date = new Date(Date.now());
  //Submit
  // private confirmShipPassingRequest: LongHaulRequestConfirmShipPassing = new LongHaulRequestConfirmShipPassing();
  private confirmShipPassingRequestResponseObject: ResponseObject = new ResponseObject();
  private isFormSubmitted: boolean = false;
  private isOptionSelectionNotValid: boolean = false;
  private isPassingDateNotValid: boolean = false;
  //Loading Components
  private noOfLoadedComponents: number = 0;
  private noOfComponentsToLoad: number = 2;
  //Form Mode
  private formMode: FormMode = FormMode.New;
  private getConfirmShipPassingObjectResponseObject: ResponseObject = new ResponseObject();
  //User Properties
  public currentUser: User = new User();
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  constructor(private datePipe: DatePipe,private circularsService: CircularService, public datepipe: DatePipe, private globalServices: GlobalServices, private router: Router, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  onCircularsRequestLoadedFlag(flag: boolean) {
    if (flag) {
      this.circularsRequestId = this.circularsRequest.rebateRequestLoaded.Id;
      this.circularsRequestOptions = this.circularsRequest.rebateRequestLoaded.CircularsFixedRebateOptions;
      this.circularsRequest.editModeAdmin = true;
      this.setFormMode();
    }
  }
  // loadComponents(): void {
  //   this.getCircularsRequestOptions();
  //   this.getConfirmShipPassingObject();
  // }
  // getCircularsRequestOptions(): void {
  //   this.getRequestOptionsDetailsRequest.LongHaulRequestId = this.circularsRequestId;
  //   for (let i: number = 0; i < this.circularsRequestOptions.length; i++) {
  //     this.getRequestOptionsDetailsRequest.LongHaulRequestOptionsFormulatedDecision[i] = new LongHaulRequestOptionFormulatedDecision();
  //     this.getRequestOptionsDetailsRequest.LongHaulRequestOptionsFormulatedDecision[i].Id = this.circularsRequestOptions[i].Id;
  //   }
  //   this.getCircularsRequestRequestorDecision();
  // }
  // getCircularsRequestRequestorDecision(): void {


  //   this.getRequestOptionsDetailsRequest.IsFormulatedDecisionComponent = true;
  //   this.circularsService.getCircularsRequestToFormulateDecision(this.getRequestOptionsDetailsRequest).subscribe(
  //     data => this.getRequestOptionsDetailsRequestResponseObject = data,
  //     () => console.log("Something went wrong!!"),
  //     () => this.getCircularsRequestRequestorDecisionCompleted()
  //   );
  // }
  // getCircularsRequestRequestorDecisionCompleted(): void {


  //   if (this.getRequestOptionsDetailsRequestResponseObject.Success) {
  //     this.getRequestOptionsDetailsResponse = this.getRequestOptionsDetailsRequestResponseObject.Data as LongHaulRequestFormulateDecision;
  //     this.checkLoadedComponents();
  //   } else {
  //     //Enable Error
  //     this.submitConfirmationMode = ConfirmationMode.Error;
  //     this.isRequestSucceeded = true;
  //     //Disable Loader
  //     this.globalServices.isLoaderEnabled = false;
  //   }
  // }
  // getConfirmShipPassingObject(): void {


  //   this.circularsService.getConfirmShipPassing(this.circularsRequestId).subscribe(
  //     data => this.getConfirmShipPassingObjectResponseObject = data,
  //     () => console.log("Something went wrong!!"),
  //     () => this.getConfirmShipPassingObjectCompleted()
  //   );
  // }
  // getConfirmShipPassingObjectCompleted(): void {
  //   if (this.getConfirmShipPassingObjectResponseObject.Success) {
  //     this.confirmShipPassingRequest = this.getConfirmShipPassingObjectResponseObject.Data as LongHaulRequestConfirmShipPassing;
  //     this.checkLoadedComponents();
  //   } else {
  //     //Enable Error
  //     this.submitConfirmationMode = ConfirmationMode.Error;
  //     this.isRequestSucceeded = true;
  //     //Disable Loader
  //     this.globalServices.isLoaderEnabled = false;
  //   }
  // }
  onOptionSelect(index: number) {
    this.isOptionDetailsEnabled = true;
    // this.selectedCircularsOption = new CircularsFixedRebateOptions();
    this.selectedCircularsOption = this.circularsRequestOptions[index];
    // console.log(this.circularsRequest.ToRegions)
    // console.log(this.selectedCircularsOption.CircularsPercentagesId)
    this.optionPercentage = this.circularsRequest.FromRegions.find(p => p.Id == this.selectedCircularsOption.CircularsPercentagesId).PercentageValue;
    console.log(this.optionPercentage)
    // this.confirmShipPassingRequest.GrantedRebatePercentage = +this.selectedCircularsOption.RebatePercentage;
    this.isOptionSelectionNotValid = false;
  }
  onShipPassedChange(): void {
    this.isOptionSelectionNotValid = false;
    this.isPassingDateNotValid = false;
  }
  onPassingDateChange(): void {

    let passingDate = this.circularsRequest.rebateRequestLoaded.PassingDate;
    console.log(passingDate)
    // if(this.confirmShipPassingRequest.PassingDate === "" || this.confirmShipPassingRequest.PassingDate === undefined)
    if (passingDate === undefined)
      this.isPassingDateNotValid = true;
    else
      this.isPassingDateNotValid = false;
  }
  submit(): void {
    let isFormValid: boolean = true;
    //Check Form Validity
    //[01] Ship Passed
    if (this.circularsRequest.rebateRequestLoaded.IsShipPassed) {
      //[01] Actual Voyage Option  ++ [02] Paasing Date
      //if((this.confirmShipPassingRequest.LongHaulRequestOptionId === "" || this.confirmShipPassingRequest.LongHaulRequestOptionId === undefined || this.confirmShipPassingRequest.LongHaulRequestOptionId === "00000000-0000-0000-0000-000000000000") && (this.confirmShipPassingRequest.PassingDate === "" || this.confirmShipPassingRequest.PassingDate === undefined || this.confirmShipPassingRequest.PassingDate === null)){
      if ((this.selectedCircularsOption.Id === "" || this.selectedCircularsOption.Id === undefined || this.selectedCircularsOption.Id === "00000000-0000-0000-0000-000000000000") && (this.circularsRequest.rebateRequestLoaded.PassingDate === undefined || this.circularsRequest.rebateRequestLoaded.PassingDate === null)) {
        this.isOptionSelectionNotValid = true;
        this.isPassingDateNotValid = true;
        isFormValid = false;
      }
      //[01] Actual Voyage Option
      else if (this.selectedCircularsOption.Id === "" || this.selectedCircularsOption.Id === undefined || this.selectedCircularsOption.Id === "00000000-0000-0000-0000-000000000000") {
        this.isOptionSelectionNotValid = true;
        isFormValid = false;
      }
      //[02] Paasing Date
      //else if(this.confirmShipPassingRequest.PassingDate === "" || this.confirmShipPassingRequest.PassingDate === undefined || this.confirmShipPassingRequest.PassingDate === null){
      else if (this.circularsRequest.rebateRequestLoaded.PassingDate === undefined || this.circularsRequest.rebateRequestLoaded.PassingDate === null) {
        this.isPassingDateNotValid = true;
        isFormValid = false;
      }
      else if (!this.selectedCircularsOption.IsGranted) {
        isFormValid = false;
      }
    }
    if (isFormValid) {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;

      // this.circularsRequest.rebateRequestLoaded.ModifiedBy = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
      this.circularsRequest.rebateRequestLoaded.CircularsFixedRebateOptions.find(o => o.Id == this.selectedCircularsOption.Id).IsUsedInPassing = true;
      this.circularsRequest.rebateRequestLoaded.CircularsFixedRebateOptions = this.circularsRequest.rebateRequestLoaded.CircularsFixedRebateOptions.filter(o => o.IsUsedInPassing)
      // if (this.circularsRequest.rebateRequestLoaded.IsShipPassed)
      //   this.confirmShipPassingRequest.TimeZoneOffset = this.confirmShipPassingRequest.PassingDate.getTimezoneOffset();
      this.circularsRequest.rebateRequestLoaded.PassingDate = new Date(this.datePipe.transform(this.circularsRequest.rebateRequestLoaded.PassingDate, "yyyy-MM-dd"));
      this.submitConfirmShipPassing();
    }
  }
  submitConfirmShipPassing(): void {
    this.circularsService.confirmShipPassing(this.circularsRequest.rebateRequestLoaded).subscribe(
      data => this.confirmShipPassingRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitConfirmShipPassingCompleted()
    );
  }
  submitConfirmShipPassingCompleted(): void {
    if (!this.confirmShipPassingRequestResponseObject.Success) {
      //Enable Error / Warning
      if (this.confirmShipPassingRequestResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if (this.confirmShipPassingRequestResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
    this.isRequestSucceeded = true;
  }
  // checkLoadedComponents(): void {
  //   this.noOfLoadedComponents++;
  //   if (this.noOfLoadedComponents == this.noOfComponentsToLoad) {
  //     this.setFormMode();
  //   }
  // }
  setFormMode(): void {
    if (this.circularsRequest.rebateRequestLoaded.IsShipPassed || (this.circularsRequest.rebateRequestLoaded.InternalStatusId != ServiceStatus.Circulars_PendingRequestorApproval && this.circularsRequest.rebateRequestLoaded.InternalStatusId != ServiceStatus.Circulars_AcceptedByRequestor && this.circularsRequest.rebateRequestLoaded.ExternalStatusId != ServiceStatus.Circulars_PendingRequestorApproval && this.circularsRequest.rebateRequestLoaded.ExternalStatusId != ServiceStatus.Circulars_AcceptedByRequestor)) {
      this.formMode = FormMode.Details;
      this.isOptionDetailsEnabled = true;
      this.selectedCircularsOption = this.circularsRequestOptions.find(l => l.IsUsedInPassing);
      this.previouslySelectedOption = this.selectedCircularsOption;
      this.optionPercentage = this.circularsRequest.ToRegions.find(p => p.Id == this.selectedCircularsOption.CircularsPercentagesId).PercentageValue;
    }
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({ behavior: 'smooth' });
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }
}

enum FormMode {
  New = 1,
  Details = 2
}

enum ConfirmationMode {
  Success = 1,
  Warning = 2,
  Error = 3
}
